/**
 * Font stacks for Orbit application
 * Lato (display) and Yantramanav (body) are loaded from Google Fonts in index.html
 */

export const fonts = {
	display: "'Lato', system-ui, -apple-system, sans-serif",
	body: "'Yantramanav', 'Lato', system-ui, sans-serif",
} as const

export const { display: fontDisplay, body: fontBody } = fonts
